module.exports = __webpack_public_path__ + "static/media/notVerified.f424d9c1.svg";